import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { DrivingExemptionForm } from "../../../shared/models/api/models";

export type DrivingExemptionFormState = {
    form: DrivingExemptionForm,
    originalForm: DrivingExemptionForm,
    formValidation: boolean[],
    checkValidation: boolean,
    emailInvalid: boolean,
    useAutoPopulatedReportToEmail: boolean
}

const emptyForm: DrivingExemptionForm = {
    id: -1
};

const createInitialState = (): DrivingExemptionFormState => ({
    form: Object.assign({}, emptyForm),
    originalForm: emptyForm,
    formValidation: [],
    checkValidation: false,
    emailInvalid: false,
    useAutoPopulatedReportToEmail: false
});

const drivingExemptionFormStateSubject = new BehaviorSubject<DrivingExemptionFormState>(createInitialState());

export const updateFormState = (form: DrivingExemptionForm) => {
    drivingExemptionFormState.setState(s => {
        s.form = form;
    });
}

const updateValidationState = (validation: boolean[]) => {
    drivingExemptionFormState.setState(s => {
        s.formValidation = validation;
    });
}

const isValueInvalid = (value: any) => {
    if (value === undefined) return true;
    if (typeof (value) === 'string' && !value.trim()) return true;
    return false;
}

export const usingRPAutoPopulatedReportToEmail = () => {
    drivingExemptionFormState.setState(d => { d.useAutoPopulatedReportToEmail = true });
}

export const enableValidation = () => {
    drivingExemptionFormState.setState(d => { d.checkValidation = true });
}

export const resetValidation = () => {
    drivingExemptionFormState.setState(d => { d.formValidation = [], d.checkValidation = false });
}

export const resetEmailValidation = () => {
    drivingExemptionFormState.setState(d => d.emailInvalid = false);
}

export const emailValidation = (emailValid: boolean) => {
    drivingExemptionFormState.setState(d => d.emailInvalid = emailValid);
}

export const handleChange = (field: string) => (event: any) => {
    let value = event;

    if (value.target?.value !== undefined) {
        value = value.target.value;
    }
    if (value.value !== undefined) {
        value = value.value;
    }
    updateFormState({ ...drivingExemptionFormStateSubject.value.form, [field]: value });
    validate(field, value);
};

export const handleCheckboxChange = (field: string) => (event: any) => {
    let value = event;
    if (value.target?.checked !== undefined) {
        value = value.target.checked;
    } else {
        value = false;
    }

    updateFormState({ ...drivingExemptionFormStateSubject.value.form, [field]: value });
    validate(field, value ? value : undefined);
}

const validate = (field: string, value: any) => {
    updateValidationState({ ...drivingExemptionFormStateSubject.value.formValidation, [field]: isValueInvalid(value) });
}

export const fieldInvalid = (field: string) => {
    if (!drivingExemptionFormStateSubject.value.checkValidation) {
        return false;
    }
    let value = Object(drivingExemptionFormStateSubject.value.formValidation)[field] as boolean;
    if (value === undefined) return true;
    return value;
}

export const drivingExemptionFormState = {
    subscribe: (setState: any) => drivingExemptionFormStateSubject.subscribe(setState),
    setState: (fn: (state: DrivingExemptionFormState) => void) => {
        var newState = Object.assign({}, drivingExemptionFormStateSubject.getValue());
        fn(newState);
        drivingExemptionFormStateSubject.next(newState);
    },
    reset: () => {
        drivingExemptionFormStateSubject.next(createInitialState())
    }
}